module.exports = __webpack_public_path__ + "static/media/product_640-2.da0b0457.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/product_640-2.jpg
// module id = 2385
// module chunks = 0